module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_pathology-7e52256c632942b5e4f8d8fa85a61f59.png";